import styled from "styled-components";
import { AppCouponGroup } from "../../molecules/coupon/AppCouponGroup";
import { AppCouponListFooter } from "../../organisms/AppCouponListFooter";
import { AppCouponExternalModal } from "../../organisms/modal/AppCouponExternalModal";
import { useAppCouponList } from "./hook";

export const AppCouponList: React.FC = () => {
  const {
    couponExternalGroups,
    selectedCouponGroup,
    handleUseCoupon,
    handleOpenModal,
    handleCloseModal,
    handleReturn,
    getQuantityOfAppliedCoupon,
    handleOpenCouponGroupModal,
    isUsingGroupCoupon,
  } = useAppCouponList();

  return (
    <Container>
      <Title>アプリクーポン利用</Title>
      <Description>アプリクーポンを選択してください</Description>
      <LayoutContent>
        {Array.isArray(couponExternalGroups) &&
          couponExternalGroups.length === 0 && (
            <NoItemsText>クーポンがありません</NoItemsText>
          )}

        {Array.isArray(couponExternalGroups) &&
          couponExternalGroups.length > 0 && (
            <CouponListContainer>
              {couponExternalGroups.map((couponGroup, index) => (
                <AppCouponGroup
                  key={`app-coupon-group-item-${couponGroup.parentCode}-${index}`}
                  couponGroup={couponGroup}
                  isUsed={isUsingGroupCoupon(couponGroup)}
                  onSelect={() => handleOpenCouponGroupModal(couponGroup)}
                />
              ))}
            </CouponListContainer>
          )}

        <AppCouponListFooter onReturn={handleReturn} />
      </LayoutContent>

      {selectedCouponGroup && (
        <AppCouponExternalModal
          isOpen={!!selectedCouponGroup}
          couponGroup={selectedCouponGroup ?? null}
          getQuantityOfAppliedCoupon={getQuantityOfAppliedCoupon}
          handleUse={handleUseCoupon}
          handleClose={handleCloseModal}
        />
      )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
`;

const Title = styled.div`
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 16px;
`;

const Description = styled.div`
  font-size: 16px;
  text-align: center;
  margin-bottom: 20px;
`;

const NoItemsText = styled.div`
  font-size: 16px;
  text-align: center;
  margin: 16px 0;
  padding: 50px 0;
`;

const CouponListContainer = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
`;

const LayoutContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  min-height: calc(100vh - 54px - 98px - 150px);
  min-width: 325px;
  max-width: 600px;
  width: 100%;
`;
